<template>
  <div :v-if="webviewHabilitada">
    <iframe
      id="iframeMultiploId"
      v-show="show && url"
      widh="100%"
      height="100%"
      :src="url"
    >
    </iframe>
  </div>
</template>
<script>
import { variavelGlobal } from '../api/variaveisGlobal.js'

export default {
  data() {
    return {
      show: false,
      url: null
    }
  },
  props: {
    webviewHabilitada: { type: Boolean, default: false }
  },
  methods: {
    openModal() {
      const th = this
      variavelGlobal.bloqueioEncerramentoSessaoPorInatividade = true
      th.show = true
      th.obterWebviewMultiplo()
    },
    obterWebviewMultiplo() {
      const th = this

      const usuario = JSON.parse(localStorage.getItem('user'))
      th.$api.Autenticacao.ObterReferenceTokenMultiplo(new Date(usuario.expiresAt).toISOString()).then(function (response) {
        if (!response.sucesso) {
          th.$api.UI.ShowError('Erro', response.mensagem)
          th.showGridContas()
        } else {
          th.url = response.url
        }
      })
    },
    showGridContas() {
      this.show = false
      this.$parent.showGrid = true
    },
    logout () {
      const th = this
      const user = this.$store.getters.user

      th.$api.Autenticacao.Logout(user.documento, user.refreshToken)
        .then(function (data) {
          if (th.$api.UI.PostLoadData(data)) {
            th.$store.commit('CLEAR_USER_DATA')
          }
        })
        .catch(err => console.log(err))
    },
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.data && event.data === 'multiplo.onboardingFinalizado') {
        this.show = false
        variavelGlobal.bloqueioEncerramentoSessaoPorInatividade = false
        window.removeEventListener('message', null)
      } else if (event.data && event.data === 'multiplo.mouseInativo') {
        window.removeEventListener('message', null)
        this.logout()
      }
    })
  }
}
</script>

<style scoped>
iframe {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 999999;
}
</style>
